import React from 'react';
import { Table } from 'antd';
import { Currency, Text } from '@common/components';
import { ShiftTypeWithIcon } from '@jobs/components';
import { ShiftType } from '@common/graphql';

function getColumns(disabled?: boolean) {
  return [
    {
      dataIndex: 'shift',
      key: 'shift',
      render: (shift: ShiftType) => (
        <ShiftTypeWithIcon disabled={disabled} value={shift} />
      ),
    },
    {
      title: 'Traveler',
      dataIndex: 'traveler',
      key: 'traveler',
      render: (rate: number) => (
        <Text secondary={disabled}>
          <Currency value={rate} />
        </Text>
      ),
    },
    {
      title: 'Local',
      dataIndex: 'local',
      key: 'local',
      render: (rate: number) => (
        <Text secondary={disabled}>
          <Currency value={rate} />
        </Text>
      ),
    },
    {
      title: 'Direct',
      dataIndex: 'direct',
      key: 'direct',
      render: (rate: number) => (
        <Text secondary={disabled}>
          <Currency value={rate} />
        </Text>
      ),
    },
  ];
}

export function RatesLongTermPreviewTable({
  dataSource,
  disabled,
}: {
  dataSource: {
    shift: ShiftType;
    traveler?: number;
    local?: number;
    direct?: number;
  }[];
  disabled?: boolean;
}) {
  const columns = getColumns(disabled);

  return (
    <Table
      className="rates-long-term-preview-table"
      columns={columns}
      dataSource={dataSource}
      pagination={false}
    />
  );
}
